<div class="footer">
	<div class="branded-asset-logo-grey"></div>
	<table class="powered-table">
		<tr>
			<td>©Copyright 2016-{{year}} | </td>
			<td *ngIf="!brand.poweredBy">GPMS International, Inc.</td>
			<td *ngIf="brand.poweredBy">Powered by</td>
			<td *ngIf="brand.poweredBy">
				<a href="https://www.gpms-vt.com/" class="branded-asset-poweredby"></a>
			</td>
		</tr>
	</table>
</div>